import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Config from "./../config.json";


export const searchApi = createApi({
    reducerPath: "searchApi",
    baseQuery: fetchBaseQuery({
      baseUrl: `${Config.IPM_SERVER_URL}/api/search/`,
      credentials: "include",
      headers: {
        "X-API-Key": Config.X_API_KEY,
      },
    }),
    endpoints: (builder) => ({

        autocomplete: builder.query({
        query: (keyword) => ({
          url: `autocomplete?keyword=${keyword}`,
          method: "GET",
        }),
      }),
    }),
  });

  export const { useAutocompleteQuery } = searchApi;
